var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "collapse firstlvl",
      attrs: { "data-level": "1", id: "navDropdown" + _vm.navDropdownCounter },
    },
    [
      _vm.isNavigationInitialized
        ? _vm._l(_vm.categories, function (category) {
            return _c("li", [
              _vm.showNextLevel(category)
                ? _c(
                    "ul",
                    { staticClass: "nav-dropdown-inner" },
                    [
                      _c("li", { staticClass: "level1" }, [
                        _c(
                          "a",
                          { attrs: { href: _vm.getCategoryUrl(category.url) } },
                          [_vm._v(_vm._s(category.details[0].name))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(category.children, function (child) {
                        return _c("desktop-navigation-node", {
                          key: child.id,
                          attrs: { category: child, level: 2 },
                        })
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          })
        : [_c("li", [_c("loading-animation")], 1)],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }